/**
 * Roving focus of a radio group (ux/01 §3.15, WAI-ARIA radio group):
 * ←/↑ previous, →/↓ next (wrapping), Début/Fin first/last; disabled options
 * are skipped.
 * @param {boolean[]} enabled  one flag per option
 * @param {number} current     index of the focused option
 * @param {string} key         KeyboardEvent.key
 * @returns {number|null}      the option to focus and select, or null
 */
export function nextRadioIndex(enabled, current, key) {
  const n = enabled.length;
  if (n === 0 || !enabled.some(Boolean)) return null;
  const step = (from, dir) => {
    let i = from;
    for (let k = 0; k < n; k += 1) {
      i = (i + dir + n) % n;
      if (enabled[i]) return i;
    }
    return null;
  };
  switch (key) {
    case "ArrowRight":
    case "ArrowDown":
      return step(current, 1);
    case "ArrowLeft":
    case "ArrowUp":
      return step(current, -1);
    case "Home":
      return enabled.indexOf(true);
    case "End":
      return n - 1 - [...enabled].reverse().indexOf(true);
    default:
      return null;
  }
}

/**
 * The numbered list (Trésorerie TWP-22 extension, TA-45 — UX 02 §13.3 « Digits 1-9 choose »): the
 * digit 1…9 typed while the focus is in the group picks the option of that rank, when it exists and
 * is enabled; any modifier, another key or a missing rank → null (the key is left alone).
 * @param {boolean[]} enabled  one flag per option
 * @param {{ key: string, ctrlKey?: boolean, altKey?: boolean, metaKey?: boolean }} e
 * @returns {number|null}
 */
export function digitRadioIndex(enabled, e) {
  if (!e || e.ctrlKey || e.altKey || e.metaKey) return null;
  if (!/^[1-9]$/.test(String(e.key ?? ""))) return null;
  const i = Number(e.key) - 1;
  return i < enabled.length && enabled[i] ? i : null;
}
